export const blobToDataURL = (blob: Blob): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.addEventListener('load', () => {
      const { result } = reader;
      if (typeof result === 'string') {
        resolve(result);
      } else if (typeof result === 'object') {
        // if typeof is object it is an ArrayBuffer, so we can cast as;
        const enc = new TextDecoder('utf-8');
        resolve(enc.decode(result as ArrayBuffer));
      } else {
        reject('Reading file returned null.');
      }
    });
    reader.addEventListener('error', () => {
      reject('Error converting Blob to string');
    });
  });
};
